"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Container = _interopRequireDefault(require("./Container"));
var _Loader = _interopRequireDefault(require("./Loader"));
var _Text = _interopRequireDefault(require("./Text"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const defaultRender = data => {
  const {
    header,
    children
  } = data;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, typeof header === 'string' ? /*#__PURE__*/_react.default.createElement(_Container.default, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: true,
    fontWeight: "600",
    minHeight: "55px",
    borderBottom: theme => `1px solid ${theme.border.border300}`
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    width: "120px",
    flex: "1 0 auto",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontWeight: "bold"
  }, header)) : header, /*#__PURE__*/_react.default.createElement(_Container.default, {
    flex: "1 1 100%"
  }, children));
};
const Loading = () => /*#__PURE__*/_react.default.createElement(_Container.default, {
  display: "flex",
  flex: "1",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%"
}, /*#__PURE__*/_react.default.createElement(_Loader.default, {
  width: "150px"
}));
const Panel = /*#__PURE__*/(0, _react.forwardRef)(({
  render,
  children,
  header,
  loading,
  ...props
}, ref) => /*#__PURE__*/_react.default.createElement(_Container.default, _extends({
  margin: "small",
  display: "flex",
  flexDirection: "column",
  ref: ref,
  border: "1px solid",
  borderColor: "border300",
  borderRadius: "0.5em",
  backgroundColor: "white"
}, props), render({
  header,
  children: loading ? /*#__PURE__*/_react.default.createElement(Loading, null) : children
})));
Panel.propTypes = {
  render: _propTypes.default.func,
  children: _propTypes.default.node,
  header: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  loading: _propTypes.default.bool
};
Panel.defaultProps = {
  render: defaultRender,
  children: null,
  header: null,
  loading: false
};
const _default = Panel;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(defaultRender, "defaultRender", "/Users/jake.clayton/frontend/ls-common-client/src/components/Panel.js");
  reactHotLoader.register(Loading, "Loading", "/Users/jake.clayton/frontend/ls-common-client/src/components/Panel.js");
  reactHotLoader.register(Panel, "Panel", "/Users/jake.clayton/frontend/ls-common-client/src/components/Panel.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/Panel.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();